export default "__VITE_ASSET__Bw8q8tW6__"